const fixSierotki =(text: string) => {
  return text.replace(/\b([aiouwzAIUOWZ])\b\s/g, '$1\u00A0');
}

export default fixSierotki;